/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

 import Api from '@/services/api';
 import Store from '@/store/store';
 
 export default {
 
   resetStore() {
     // reset store to empty
     Store.dispatch('campaigns/setCampaigns', {
       cms: [],
     });
   },
 
   // Hit the list_all route and cache the list of campaigns in the Store, or return the error message
   async listAll(refreshFromAPI: boolean) {
 
     // check if we need to force an API refresh or have already fetched this data and it is in the Store
     if (refreshFromAPI || Store.getters['campaigns/campaigns'].length < 1) {
       try {
         const response = await Api().get('/campaign/list_all');
         
         if (response && response.data && response.data.result && response.data.result === 'false') {
           this.resetStore();
           return response.data.message;
         } else {
           Store.dispatch('campaigns/setCampaigns', {
             campaigns: response.data,
           });
           return '';
         }
 
       } catch (error) {
         this.resetStore();
         if (error.response) {
           return error.response.statusText;
         } else {
           return Store.getters['app/messages'].couldNotConnect;
         }
       } 
     } else {
       // this data is ready to access in the Store
       return '';
     }
   },  
 }; 
